import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";

const F = ({ id, label, children }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">{label}</Label>
    {children}
  </div>
);

function calcAge(dob) {
  if (!dob) return "";
  const d = new Date(dob);
  if (isNaN(d)) return "";
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
  return age >= 0 ? String(age) : "";
}

export default function PatientForm({ patient, arrival, onPatient, onArrival }) {
  const eta = patient.data_nascita ? calcAge(patient.data_nascita) : "";

  return (
    <div className="bg-white border border-slate-200 rounded-md p-6">
      <h3 className="font-heading text-lg font-semibold mb-4">Dati paziente</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <F id="cognome" label="Cognome">
          <Input id="cognome" data-testid="input-cognome" value={patient.cognome || ""}
                 onChange={(e) => onPatient({ ...patient, cognome: e.target.value })} />
        </F>
        <F id="nome" label="Nome">
          <Input id="nome" data-testid="input-nome" value={patient.nome || ""}
                 onChange={(e) => onPatient({ ...patient, nome: e.target.value })} />
        </F>
        <F id="data_nascita" label="Data nascita">
          <Input id="data_nascita" type="date" data-testid="input-data-nascita" value={patient.data_nascita || ""}
                 onChange={(e) => onPatient({ ...patient, data_nascita: e.target.value, eta: calcAge(e.target.value) })} />
        </F>
        <F id="eta" label="Età">
          <Input id="eta" data-testid="input-eta" value={eta} readOnly className="bg-slate-50 font-mono" />
        </F>
        <F id="sesso" label="Sesso">
          <Select value={patient.sesso || ""} onValueChange={(v) => onPatient({ ...patient, sesso: v })}>
            <SelectTrigger data-testid="select-sesso"><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="M">M</SelectItem>
              <SelectItem value="F">F</SelectItem>
              <SelectItem value="X">Altro / non dichiarato</SelectItem>
            </SelectContent>
          </Select>
        </F>
        <F id="cf" label="Codice Fiscale (facoltativo)">
          <Input id="cf" data-testid="input-cf" value={patient.cf || ""}
                 onChange={(e) => onPatient({ ...patient, cf: e.target.value.toUpperCase() })} />
        </F>
        <F id="accesso_ps" label="N. Accesso PS">
          <Input id="accesso_ps" data-testid="input-accesso-ps" value={patient.accesso_ps || ""}
                 onChange={(e) => onPatient({ ...patient, accesso_ps: e.target.value })} />
        </F>
        <F id="modalita" label="Modalità arrivo">
          <Select value={arrival.modalita || ""} onValueChange={(v) => onArrival({ ...arrival, modalita: v })}>
            <SelectTrigger data-testid="select-modalita"><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="118">118</SelectItem>
              <SelectItem value="autonomo">Autonomo</SelectItem>
              <SelectItem value="elisoccorso">Elisoccorso</SelectItem>
              <SelectItem value="trasferito">Trasferito</SelectItem>
            </SelectContent>
          </Select>
        </F>
        <F id="ora_accettazione" label="Ora accettazione">
          <Input id="ora_accettazione" type="time" data-testid="input-ora-accettazione"
                 value={arrival.ora_accettazione || ""} onChange={(e) => onArrival({ ...arrival, ora_accettazione: e.target.value })} />
        </F>
        <F id="ora_presa" label="Ora presa in carico">
          <Input id="ora_presa" type="time" data-testid="input-ora-presa"
                 value={arrival.ora_presa || ""} onChange={(e) => onArrival({ ...arrival, ora_presa: e.target.value })} />
        </F>
        <F id="allergie" label="Allergie">
          <Input id="allergie" data-testid="input-allergie" value={patient.allergie || ""}
                 onChange={(e) => onPatient({ ...patient, allergie: e.target.value })} />
        </F>
        <F id="terapie" label="Terapie domiciliari">
          <Input id="terapie" data-testid="input-terapie" value={patient.terapie || ""}
                 onChange={(e) => onPatient({ ...patient, terapie: e.target.value })} />
        </F>
      </div>
    </div>
  );
}
